import { EMAIL_REGEX, PHONE_NUMBER_REGEX } from "../constants/auth";

export function validatePhoneNumber(phoneNumber: string): boolean {
  return PHONE_NUMBER_REGEX.test(phoneNumber);
}

export function validateEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function validatePassword(password: string): boolean {
  const baseRegex = /^[^\s]{8,24}$/;

  if (!baseRegex.test(password)) return false;

  let matches = 0;

  if (/[a-z]/.test(password)) matches++;
  if (/[A-Z]/.test(password)) matches++;
  if (/\d/.test(password)) matches++;
  if (/[!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]/.test(password)) matches++;

  return matches >= 2;
}
